import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const initAnim = () => {
  const settings = {
    duration: 0.6,
  };

  const initScrollTrigger = (tl, el, start = "top bottom-=20%") => {
    ScrollTrigger.create({
      animation: tl,
      trigger: el,
      start: () => start,
    });
  };

  const getDefaultAnim = (from, to) => {
    return [{
        opacity: 0,
        y: "100px",
        ...from,
      },
      {
        opacity: 1,
        y: 0,
        duration: settings.duration,
        stagger: 0.4,
        ease: "power1.out",
        ...to,
      },
    ];
  };

  const riseUp = document.querySelectorAll("[data-rise-up]");
  riseUp.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let duration = el.getAttribute('data-duration') || settings.duration;
    let start = el.getAttribute('data-start') || 'top bottom-=20%';
    const tl = gsap.fromTo(el, ...getDefaultAnim({}, {
      delay: delay,
      duration: duration,
    }));
    if (el.closest('[data-rise-up-group]')) {
      initScrollTrigger(tl, el.closest('[data-rise-up-group]'));
    } else {
      initScrollTrigger(tl, el, start);
    }
  });

  const animRight = document.querySelectorAll('[data-anim-right]');
  animRight.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=20%';
    const tl = gsap.fromTo(el, {
      x: '100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "power1.out",
      delay: delay,
    });
    initScrollTrigger(tl, el, start);
  });

  const animLeft = document.querySelectorAll('[data-anim-left]');
  animLeft.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=-20%';
    const tl = gsap.fromTo(el, {
      x: '-100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "power1.out",
      delay: delay,
    });
    initScrollTrigger(tl, el, start);
  });

  const listRiseUpAnim = document.querySelectorAll('[data-rise-list]');
  listRiseUpAnim.forEach((el) => {
    const items = el.querySelectorAll('[data-rise-item]');
    let start = el.getAttribute('data-start') || 'top bottom-=-20%';
    let delay = el.getAttribute('data-delay') || 0;
    const tl = gsap.fromTo(items, {
      y: '120%',
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "ease",
      delay: delay,
      stagger: 0.2,
    });

    initScrollTrigger(tl, el, start);
  });

  const listLeftAnim = document.querySelectorAll('[data-left-list]');
  listLeftAnim.forEach((el) => {
    const items = el.querySelectorAll('[data-left-item]');
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=-20%';
    const tl = gsap.fromTo(items, {
      x: '-100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "ease",
      delay: delay,
      stagger: 0.2,
    });

    initScrollTrigger(tl, el, start);
  });

  const decorationAnim = document.querySelectorAll('.js-decoration');

  decorationAnim.forEach((el) => {
    const paths = el.querySelectorAll('.js-decoration-svg path');
    const svgEls = el.querySelectorAll('.js-decoration-svg');
    const hasWave = Array.from(svgEls).some((svg) => svg.classList.contains('section-numbers-wave-wave'));
    const baseDuration = hasWave ? 0.4 : 0.5;
    const baseEase = hasWave ? 'power1.inOut' : 'power1.out';

    const tl = gsap.timeline({
      defaults: {
        duration: baseDuration,
        ease: baseEase,
      },
    });

    paths.forEach((path) => {
      const length = path.getTotalLength();

      gsap.set(path, {
        strokeDasharray: length,
        strokeDashoffset: length,
        visibility: "hidden",
      });

      tl.to(path, {
        strokeDashoffset: 0,
        visibility: "visible",
      });
    });

    initScrollTrigger(tl, el);
  });

  ScrollTrigger.sort();
};

document.addEventListener('DOMContentLoaded', () => {
  const allMenuItems = document.querySelectorAll('.nav-main__menu .menu-item');
  const globalDelay = 0.6;
  const staggerDelay = 0.07;

  allMenuItems.forEach((item, index) => {
    const totalDelay = globalDelay + (index * staggerDelay);
    item.style.setProperty('--delay', `${totalDelay}s`);
  });
});
